import { render, staticRenderFns } from "./comnike.vue?vue&type=template&id=63a48b2d&"
import script from "./comnike.vue?vue&type=script&lang=js&"
export * from "./comnike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QImg,QSpace,QInput,QCardSection} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QImg,QSpace,QInput,QCardSection}, component.options.components || {})
